import { render, staticRenderFns } from "./tab_referencias_personales.vue?vue&type=template&id=017c109d&scoped=true"
import script from "./tab_referencias_personales.vue?vue&type=script&lang=js"
export * from "./tab_referencias_personales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017c109d",
  null
  
)

export default component.exports